var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btn_templtes",
    transform: "translate(-10.675 0.26)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1220",
    "data-name": "Rectangle 1220",
    width: 24,
    height: 24,
    transform: "translate(10.675 -0.26)",
    fill: "rgba(255,255,255,0.01)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "portfolio",
    transform: "translate(13.675 1.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1871",
    "data-name": "Group 1871",
    transform: "translate(1.873 4.619)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1578",
    "data-name": "Path 1578",
    d: "M197.9,455.937v-.612a4.23,4.23,0,0,1,2.9-.924,4.323,4.323,0,0,1,2.917.924v.612",
    transform: "translate(-195.358 -453.485)",
    fill: "none",
    stroke: "#0a3b58",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1579",
    "data-name": "Path 1579",
    d: "M187.452,474.452v5.2a.612.612,0,0,0,.612.612H200.3a.612.612,0,0,0,.612-.612v-4.714",
    transform: "translate(-187.146 -467.41)",
    fill: "none",
    stroke: "#0a3b58",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1113",
    "data-name": "Rectangle 1113",
    width: 1.835,
    height: 2.141,
    rx: 0.871,
    transform: "translate(6.117 7.347)",
    fill: "none",
    stroke: "#0a3b58",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1580",
    "data-name": "Path 1580",
    d: "M194.534,467.2a26.367,26.367,0,0,0,5.654-.8.61.61,0,0,0,.464-.593V462a.612.612,0,0,0-.612-.612H187.193a.612.612,0,0,0-.612.612v3.531a.609.609,0,0,0,.428.583,22.718,22.718,0,0,0,5.69,1.084",
    transform: "translate(-186.581 -458.934)",
    fill: "none",
    stroke: "#0a3b58",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1581",
    "data-name": "Path 1581",
    d: "M190.074,450.379l-.535-1.448L177,452.461l2.23,7.465",
    transform: "translate(-177 -446.418)",
    fill: "none",
    stroke: "#0a3b58",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1873",
    "data-name": "Group 1873",
    transform: "translate(10.595 2.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1584",
    "data-name": "Path 1584",
    d: "M216.072,447.914l.493-.492,1.73-4.326-4.326,1.73-2.551,2.551",
    transform: "translate(-211.418 -443.097)",
    fill: "none",
    stroke: "#0a3b58",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    x2: 0.433,
    y2: 0.433,
    transform: "translate(6.012 0.433)",
    fill: "none",
    stroke: "#0a3b58",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1585",
    "data-name": "Path 1585",
    d: "M221.142,453.632l-1.3-1.3-1.038,1.038",
    transform: "translate(-216.212 -449.091)",
    fill: "none",
    stroke: "#0a3b58",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.e1be10117bd704c273286d030fda0e78.svg";
export { ForwardRef as ReactComponent };